<template>
    <div>
        <el-form :inline="true">
            <el-form-item>
                <el-input
                        v-model="searchForm.subject"
                        placeholder="邮件主题"
                        clearable
                >
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-input
                        v-model="searchForm.recipient"
                        placeholder="收件人"
                        clearable
                >
                </el-input>
            </el-form-item>

            <el-form-item>
                <el-button @click="getSendRecodeList">搜索</el-button>
            </el-form-item>
        </el-form>

        <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                border
                stripe>

            <el-table-column
                    prop="subject"
                    label="邮件主题"
                    width="300">
            </el-table-column>
            <el-table-column
                    prop="sendType"
                    label="发送类型"
                    width="150">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.sendType === 1">模板发送</el-tag>
                    <el-tag v-if="scope.row.sendType === 2">自定义发送</el-tag>
                </template>

            </el-table-column>
            <el-table-column
                    prop="recipient"
                    label="收件人">
            </el-table-column>
            <el-table-column
                    prop="content"
                    label="发送内容"
                    width="200">
                <template slot-scope="scope">
                    <el-tag size="small" type="success"><span @click="openPreview(scope.row.content)">HTML</span></el-tag>
                </template>
            </el-table-column>

            <el-table-column
                    prop="isSendSuccess"
                    label="是否发送"
                    width="100">
                <template slot-scope="scope">
                    <el-tag size="warning" v-if="scope.row.isSendSuccess === 1" type="success">是</el-tag>
                    <el-tag size="warning" v-else-if="scope.row.isSendSuccess === 0" type="danger">否</el-tag>
                </template>

            </el-table-column>
            <el-table-column
                    prop="sendTime"
                    width="200"
                    label="发送时间"
            >
            </el-table-column>
        </el-table>

        <!--预览弹框-->
        <el-dialog
                title="邮件内容预览"
                :visible.sync="dialogVisible"
                width="40%">
            <div style="border: 2px solid;">
                <div style="margin: 10px" v-html="preview"></div>
            </div>
        </el-dialog>

        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 20, 50, 100]"
                :current-page="page.current"
                :page-size="page.size"
                :total="page.total">
        </el-pagination>

    </div>
</template>

<script>
    export default {
        name: "Role",
        data() {
            return {
                preview: "",
                dialogVisible: false,
                searchForm: {},
                page: {
                  total: 0,
                  size: 10,
                  current: 1,
                },
                tableData: []
            }
        },
        created() {
            this.getSendRecodeList(this.page)
        },
        methods: {
            openPreview(content) {
                console.log('cccc',content)
                this.dialogVisible = true
                this.preview = content
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.page.size = val
                this.getSendRecodeList(this.page)
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.page.current = val
                this.getSendRecodeList(this.page)
            },
            getSendRecodeList(page) {
                this.$axios.post("/uxm/email-send/page", {
                    subject: this.searchForm.subject,
                    recipient: this.searchForm.recipient,
                    current: page == null ? this.page.current : page.current,
                    size: page == null ? this.page.size : page.size,
                }).then(res => {
                    this.tableData = res.data.data.records
                    this.page.size = res.data.data.size
                    this.page.current = res.data.data.current
                    this.page.total = res.data.data.total
                })
            }
        }
    }
</script>

<style scoped>

    .el-pagination {
        float: right;
        margin-top: 22px;
    }

</style>
